import MKTECH_EXT_1 from "./MKTECH_EXT_1";

export default {
  MKTECH_EXT_1,
};
